import React, { Component } from 'react';
import styles from './styles.module.scss';

export default class CustomVideo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false
    };

    this.togglePlay = this.togglePlay.bind(this);
    this.video = React.createRef();
  }

  togglePlay() {
    this.setState({ playing: !this.state.playing }, () => {
      if (this.state.playing) {
        this.video.current.play();
      } else {
        this.video.current.pause();
      }
    });
  }

  render() {
    const {
      src,
      poster,
      icon,
      className
    } = this.props;
    const { playing } = this.state;

    return (
      <div onClick={this.togglePlay} className={`${className || ''} ${styles.customVideo}`}>
        <video
          onClick={this.togglePlay}
          src={src}
          poster={poster}
          ref={this.video}
        />
        {!playing && <img src={icon} />}
      </div>
    );
  }
}
